import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 6px 0;
  margin-bottom: 10px;
  ${({ $error }) =>
    $error &&
    `
      border: 1px solid #f5a623;
      border-radius: var(--border-radius8);
      background-color: #fef3e4;
    `}
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ButtonWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  width: ${({ width }) => `calc(${width} - 10px)`};
`;

export const InputWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: ${({ width }) => `calc(${width} - 10px)`};
`;

export const IconButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 40px;
  position: absolute;
  inset: 6px calc(100% + 10px) auto auto;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: var(--color-greyF8);
  border-radius: var(--border-radius8);
  border: none;
  outline: none;
  cursor: pointer;
  &:hover {
    background: var(--color-greyEC);
  }
`;

export const Text = styled.p`
  font-size: var(--font-size20);
  color: var(--color-grey6A);
  text-align: left;
  padding: 0 5px;
`;
